// Ported from mobile/src/utils/translationKeys.ts
const ELEC_MAP = {
  "دانانی بۆری": { en: "Pipe Installation", ku: "دانانی بۆری" },
  "راکێشانی وایەر": { en: "Wire Pulling", ku: "راکێشانی وایەر" },
  "دانانی سەرگەچ": { en: "Above Plaster Installation", ku: "دانانی سەرگەچ" },
  "تێستکردن": { en: "Testing", ku: "تێستکردن" },
};

const MECH_MAP = {
  "شۆفاژ": { en: "Heating / Radiator", ku: "شۆفاژ" },
  "درەین سپلێت": { en: "Drain Split", ku: "درەین سپلێت" },
  "بۆری هەوا/ ساحیبە": { en: "Air Pipe / Sahiba", ku: "بۆری هەوا/ ساحیبە" },
  "کاری میکانیک سەر گەچ": { en: "Mechanic Work on Plaster", ku: "کاری میکانیک سەر گەچ" },
  "تێست کردنی بۆری ئاو و ئاوەڕۆ": { en: "Water & Drainage Pipe Testing", ku: "تێست کردنی بۆری ئاو و ئاوەڕۆ" },
  "سپلێت": { en: "Split AC", ku: "سپلێت" },
  "بۆری سپلێت": { en: "Split Pipe", ku: "بۆری سپلێت" },
  "دەکت": { en: "Duct", ku: "دەکت" },
  "ئاوەڕۆ": { en: "Drainage", ku: "ئاوەڕۆ" },
  "ئاو": { en: "Water", ku: "ئاو" },
  "ئاو/قۆناغی ١": { en: "Water / Phase 1", ku: "ئاو/قۆناغی ١" },
  "ئاو/قۆناغی ٢": { en: "Water / Phase 2", ku: "ئاو/قۆناغی ٢" },
  "ئاوەڕۆی ئەرزی": { en: "Ground Drainage", ku: "ئاوەڕۆی ئەرزی" },
  "ئاوەڕۆی سەقفی/ قۆناغی ١": { en: "Ceiling Drainage / Phase 1", ku: "ئاوەڕۆی سەقفی/ قۆناغی ١" },
  "ئاوەڕۆی سەقفی/ قۆناغی ٢": { en: "Ceiling Drainage / Phase 2", ku: "ئاوەڕۆی سەقفی/ قۆناغی ٢" },
  "ئاوەڕۆی دەرەوەی ڤێلا/قۆناغی ١": { en: "External Villa Drainage / Phase 1", ku: "ئاوەڕۆی دەرەوەی ڤێلا/قۆناغی ١" },
  "ئاوەڕۆی دەرەوەی ڤێلا/قۆناغی ٢": { en: "External Villa Drainage / Phase 2", ku: "ئاوەڕۆی دەرەوەی ڤێلا/قۆناغی ٢" },
};

const STRUCT_MAP = {
  "دیواری ڕگر": { en: "Retaining Wall", ku: "دیواری ڕگر" },
  "هەیکەل": { en: "Structure Frame", ku: "هەیکەل" },
  "شمشە و ماڵە چی": { en: "Formwork & Scaffolding", ku: "شمشە و ماڵە چی" },
  "شوێن بۆکسی باخی ڤێلاکان": { en: "Villa Garden Box Location", ku: "شوێن بۆکسی باخی ڤێلاکان" },
  "کاری خشت": { en: "Brick Work", ku: "کاری خشت" },
  "سەر پەنجەرە": { en: "Window Lintel", ku: "سەر پەنجەرە" },
  "مەرەدی ناو دەرگا": { en: "Door Frame", ku: "مەرەدی ناو دەرگا" },
  "کاری بلۆک کاری": { en: "Block Work", ku: "کاری بلۆک کاری" },
  "کاری معالەجە": { en: "Treatment Work", ku: "کاری معالەجە" },
  "أساس (کۆنکرێت)": { en: "Foundation (Concrete)", ku: "أساس (کۆنکرێت)" },
  "بلۆککاری": { en: "Block Work", ku: "بلۆککاری" },
  "لین کۆنکرێت": { en: "Lean Concrete", ku: "لین کۆنکرێت" },
  "حەوشە": { en: "Yard", ku: "حەوشە" },
  "باڵکۆن": { en: "Balcony", ku: "باڵکۆن" },
  "ستارە": { en: "Column", ku: "ستارە" },
  "سیاجی ڤێلاکان": { en: "Villa Fencing", ku: "سیاجی ڤێلاکان" },
  "سیاجی باخەکان": { en: "Garden Fencing", ku: "سیاجی باخەکان" },
  "معالەجەی ناوەوە": { en: "Interior Treatment", ku: "معالەجەی ناوەوە" },
  "معالەجەی دەرەوە": { en: "Exterior Treatment", ku: "معالەجەی دەرەوە" },
  "معالەجەی دکت": { en: "Duct Treatment", ku: "معالەجەی دکت" },
  "معالەجەی بۆری": { en: "Pipe Treatment", ku: "معالەجەی بۆری" },
  "کاری بلۆککاری لە نێوان ستوونەکان": { en: "Brick Work between Pillars", ku: "کاری خشتکاری لە نێوان ستوونەکان" },
};

const FINISH_MAP = {
  "کاری دەرەوەی ڤێلا": { en: "Exterior Villa Work", ku: "کاری دەرەوەی ڤێلا" },
  "کاری ناوەوی ڤێلا": { en: "Interior Villa Work", ku: "کاری ناوەوی ڤێلا" },
  "لەبغی دەرەوە": { en: "Exterior Plaster", ku: "لەبغی دەرەوە" },
  "لەبغی بەشی خوارەوەی گەچ": { en: "Plaster Under Gypsum", ku: "لەبغی بەشی خوارەوەی گەچ" },
  "پۆرسەلین": { en: "Porcelain", ku: "پۆرسەلین" },
  "کاری ئاسنگەری": { en: "Ironwork", ku: "کاری ئاسنگەری" },
  "بۆیاخ": { en: "Paint", ku: "بۆیاخ" },
  "واجیهەی تەختە و ئەلەمنیۆم": { en: "Board & Aluminum Facade", ku: "واجیهەی تەختە و ئەلەمنیۆم" },
  "سەوزای": { en: "Landscaping", ku: "سەوزای" },
  "کەپر(Shading)": { en: "Shading", ku: "کەپر(Shading)" },
  "Labeling": { en: "Labeling", ku: "Labeling" },
  "مەرەدی پەنجەرە": { en: "Window Frame", ku: "مەرەدی پەنجەرە" },
  "شاپ": { en: "Screed", ku: "شاپ" },
  "ئەلەمنیۆم": { en: "Aluminum", ku: "ئەلەمنیۆم" },
  "شوشە": { en: "Glass", ku: "شوشە" },
  "کاشی": { en: "Tiles", ku: "کاشی" },
  "سقف سانەوی": { en: "False Ceiling", ku: "سقف سانەوی" },
  "لامینەیت ئەرزی": { en: "Floor Laminate", ku: "لامینەیت ئەرزی" },
  "ازاره": { en: "Skirting", ku: "ازاره" },
  "دەرگا": { en: "Door", ku: "دەرگا" },
  "Final Touch": { en: "Final Touch", ku: "Final Touch" },
  "لەبغی تورکی": { en: "Turkish Plaster", ku: "لەبغی تورکی" },
  "گەچکاری": { en: "Gypsum Work", ku: "گەچکاری" },
  "مەڕمەڕ": { en: "Marble", ku: "مەڕمەڕ" },
  "تێرمۆسیڤا": { en: "Thermosiva", ku: "تێرمۆسیڤا" },
  "ژێر سەقف": { en: "Under Ceiling", ku: "ژێر سەقف" },
  "سیاجی دەرەوە": { en: "Exterior Fence", ku: "سیاجی دەرەوە" },
  "گڵگەچ": { en: "Gypsum Plaster", ku: "گڵگەچ" },
  "سپیکاری": { en: "White Coating", ku: "سپیکاری" },
  "پەنجەرە": { en: "Window", ku: "پەنجەرە" },
  "پلە قادرمە": { en: "Stair Railing", ku: "پلە قادرمە" },
  "حمام تورکی": { en: "Turkish Bath", ku: "حمام تورکی" },
  "شاوەر": { en: "Shower", ku: "شاوەر" },
  "دەرگا و پەنجەرە": { en: "Door & Window", ku: "دەرگا و پەنجەرە" },
  "باڵکۆنی": { en: "Balcony", ku: "باڵکۆنی" },
  "قادرمە": { en: "Railing", ku: "قادرمە" },
  "کناف": { en: "Knauf", ku: "کناف" },
  "بۆردێکس": { en: "Bordex", ku: "بۆردێکس" },
  "Z پرۆفایل": { en: "Z Profile", ku: "Z پرۆفایل" },
  "تەختە(سروشتی)": { en: "Board (Natural)", ku: "تەختە(سروشتی)" },
  "تەختە (پلاستیک)": { en: "Board (Plastic)", ku: "تەختە (پلاستیک)" },
  "مدخەل": { en: "Entrance", ku: "مدخەل" },
  "ناوەوە": { en: "Interior", ku: "ناوەوە" },
  "دارتاشی": { en: "Carpentry", ku: "دارتاشی" },
  "پلاستیک": { en: "Plastic", ku: "پلاستیک" },
  "سیاج و دەرگا": { en: "Fence & Door", ku: "سیاج و دەرگا" },
  "بۆیاخی بینا": { en: "Building Paint", ku: "بۆیاخی بینا" },
  "دەرەوە": { en: "Exterior", ku: "دەرەوە" },
  "ئەرزی": { en: "Floor", ku: "ئەرزی" },
  "ئیزارە": { en: "Skirting", ku: "ئیزارە" },
  "دیوار": { en: "Wall", ku: "دیوار" },
  "سقف": { en: "Ceiling", ku: "سقف" },
};

const ALL_KEYS = { ...ELEC_MAP, ...MECH_MAP, ...STRUCT_MAP, ...FINISH_MAP };

export function translateKey(key, language) {
  if (!key) return "-";
  const entry = ALL_KEYS[key];
  if (entry) return entry[language];
  return key;
}
